export const DASHBOARD_IMAGES = process.env.REACT_APP_BUCKET_URL || '';
export const DASHBOARD_API = process.env.REACT_APP_DASHBOARD_API || '';
export const BOOK_API = process.env.REACT_APP_BOOK_API || '';
export const CALENDAR_API_KEY = process.env.REACT_APP_CALENDAR_API_KEY || '';
export const ADMIN_TOKEN = process.env.REACT_APP_ADMIN_TOKEN || '';
export const DASHBOARD_URL = process.env.REACT_APP_DASHBOARD_URL || '';
